var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_account_header"},[_c('h2',{staticClass:"page_account_header__title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"page_account_header__desc"},[(_vm.$slots.desc)?_vm._t("desc"):[_vm._v(_vm._s(_vm.desc))]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }